import { useEffect, useRef } from 'react';
import { focusManager } from '@tanstack/react-query';
import { FOREGROUND_PROFILE_REFETCH_THROTTLE_MS } from '../constants/appForeground.constants';

/**
 * Re-fetch user profile (coins, avatar, arena stats) when the app regains focus.
 * Profile lives outside React Query; this keeps cross-device sessions in sync.
 */
export function useProfileForegroundRefresh(
  refetchProfile: () => Promise<void>,
  enabled: boolean,
): void {
  const refetchRef = useRef(refetchProfile);
  const lastRefetchAtRef = useRef(0);

  refetchRef.current = refetchProfile;

  useEffect(() => {
    if (!enabled) return;

    return focusManager.subscribe((focused) => {
      if (!focused) return;
      const now = Date.now();
      if (now - lastRefetchAtRef.current < FOREGROUND_PROFILE_REFETCH_THROTTLE_MS) {
        return;
      }
      lastRefetchAtRef.current = now;
      void refetchRef.current();
    });
  }, [enabled]);
}
